module.exports = __webpack_public_path__ + "img/windows10.41c5ccf1.webp";